import { useSelector } from "react-redux";
import CategoryLinksList from "./CategoryLinksList";
import styles from "./CategoryHeaderLinks.css";
import HorizontalScrollListVariant from "../../../../../HorizontalScrollList/components/HorizontalScrollListVariant";
import { getCategorySeoLinks } from "../../../../../../state/modules/category/selectors";

const CategoryHeaderLinks = () => {
  const { primarySeoLinks } = useSelector(getCategorySeoLinks);
  if (!primarySeoLinks.length) return null;

  return (
    <span className={styles.list}>
      <HorizontalScrollListVariant
        scrollSnapping={false}
        className={styles.categoryHeaderLinks}
      >
        <CategoryLinksList links={primarySeoLinks} />
      </HorizontalScrollListVariant>
    </span>
  );
};

export default CategoryHeaderLinks;
